var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useRef } from 'react';
import Button from '@r1-frontend/ui-react/components/buttons/button';
import { SearchInput } from '@r1-frontend/ui-react/components/input/search';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Select from '@r1-frontend/ui-react/components/select/select';
import { SearchNormal } from '@r1-frontend/ui-react/components/svg/search';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';
import * as ST from './styled';
var ChannelsFilters = function (_a) {
    var isShowSearch = _a.isShowSearch, channels = _a.channels, selectedFilter = _a.selectedFilter, preparedThemes = _a.preparedThemes, onChangeChannelTheme = _a.onChangeChannelTheme, onShowSearchInput = _a.onShowSearchInput, onClearSearch = _a.onClearSearch, onChangeSearch = _a.onChangeSearch, value = _a.value;
    var isMobile = useMatchMedia("(max-width: ".concat(wideBreakpoints.mobile, ")"));
    var searchRef = useRef(null);
    return (<ST.Wrapper data-test='channels-filters'>
            {!isShowSearch
            ? <ST.ChannelsSelector>
                        <Select options={preparedThemes} value={selectedFilter.value === 0 && (preparedThemes === null || preparedThemes === void 0 ? void 0 : preparedThemes.length)
                    ? preparedThemes[0]
                    : selectedFilter} onChange={onChangeChannelTheme} width={'100%'} maxMenuHeight={300} placeholder={'Все каналы'} noOptionsMessage={'Нет категорий'} data-test='channels-filters-themes' isDisabled={!(preparedThemes === null || preparedThemes === void 0 ? void 0 : preparedThemes.length)} styles={{
                    singleValue: function (provided) { return (__assign(__assign({}, provided), { color: COLORS.Disabled })); },
                }}/>
                        <Button Icon={<SearchNormal />} size={'large'} bType={'secondary'} disabled={!(preparedThemes === null || preparedThemes === void 0 ? void 0 : preparedThemes.length)} rounded={!isMobile} onClick={function (e) { return onShowSearchInput(e); }} data-test='channels-filters-open-search-button'>
                            {isMobile ? 'Поиск' : null}
                        </Button>
                    </ST.ChannelsSelector>
            : <ST.FiltersSearch>
                        <SearchInput ref={searchRef} placeholder='Найдите канал' items={channels} onClear={onClearSearch} value={value} onChange={onChangeSearch} onClick={function (e) { return e.stopPropagation(); }} isClearBtnHide={!value} data-test='channels-filters-search-input'/>
                    </ST.FiltersSearch>}
        </ST.Wrapper>);
};
export default ChannelsFilters;
